import React from 'react';
import './styles/LoadingBar.css';

function LoadingBar() {
    return (
        <div className="loading-bar-container">
            <div className="loading-bar"></div>
        </div>
    );
}

export default LoadingBar;
